import React from 'react';
import './LanguageDropdown.css';

function LanguageDropdown({ onSelect, disabledLanguage }) {
  const languages = [
    "English",
    "French",
    "German",
    "Indonesian",
    "Italian",
    "Japanese",
    "Malay",
    "Mandarin",
    "Spanish",
    "Thai"
  ];

  return (
    <select
      className="language-dropdown"
      onChange={(e) => onSelect(e.target.value)}
      defaultValue=""
    >
      <option value="" disabled>Select a language</option>
      {languages.map((language) => {
        const value = language.toLowerCase(); // -> english, indonesian, malay, ...
        const isDisabled =
          (disabledLanguage || '').toLowerCase() === value;

        return (
          <option key={language} value={value} disabled={isDisabled}>
            {language}
          </option>
        );
      })}
    </select>
  );
}

export default LanguageDropdown;
